import { NotificationService } from '../services';
import { observable } from 'mobx';

export class ServiceStore {
    @observable notificationService: NotificationService;

    constructor(notificationService: NotificationService) {
        this.notificationService = notificationService;
    }
}


// WEBPACK FOOTER //
// ./src/stores/ServiceStore.tsx